import React, { useState, useEffect, useMemo } from "react";
import ReactEcharts from "echarts-for-react";
import getChartColorsArray from "../../Components/Common/ChartsDynamicColor";
import { Button } from "reactstrap";

// Utility to get previous month names based on a number of months
function getPreviousMonths(numMonths) {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const result = [];
    const date = new Date();

    for (let i = 0; i < numMonths; i++) {
        result.push(months[date.getMonth()]);
        date.setMonth(date.getMonth() - 1);
    }

    return result.reverse();
}

const Token_Usage_Chart = ({ month_count, token_usages, setmonthly_record, dataColor, bgColor }) => {
    const [xAxisData, setXAxisData] = useState([]);
    
    // Update xAxisData whenever month_count changes
    useEffect(() => {
        setXAxisData(getPreviousMonths(token_usages.length));


        
    }, [month_count, token_usages.length]);

    // Memoize chart options to prevent re-rendering unless data changes
    const option = {
        tooltip: {
            trigger: 'item',
            responsive: true,
            position: 'top',
            valueFormatter: function (params) {
                return `${params.toLocaleString()}`;
              },
            backgroundColor: '#fafcfe',
            borderColor: '#c8e2f7',
            borderWidth: '0.8',
            textStyle: {
                color: '#5d6f80'
            }
        },
        grid: {
            left: '1%',
            right: '6%',
            bottom: '4%',
            top: '4%',
            containLabel: true,
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xAxisData,
            axisLine: { lineStyle: { color: '#858d98' } },
        },
        yAxis: {
            type: 'value',
            axisLabel: {
              formatter: (value) => {
                // Divide the value by 1000 and display
                return (value / 1000).toFixed(0); // You can adjust the decimal places as needed
              },
            },
            axisLine: { lineStyle: { color: '#858d98' } },
            splitLine: { lineStyle: { color: "rgba(133, 141, 152, 0.1)" } },
        },
        series: [
            {
                data: token_usages.map((ele) => ele.MonthlyTokenUsed),
                type: 'line',
                areaStyle: {},
                
            },
        ],
        textStyle: { fontFamily: 'Poppins, sans-serif' },
        color: '#FFEECF80',
        backgroundColor: bgColor,
        
}

    return (
        <React.Fragment>
            <div className="filter_by_bots">
                <div className="d-flex">
                    <div className="d-flex token_usage_wrap">
                        <h3>Token usage</h3>
                        {/* Optional filters dropdown */}
                    </div>
                    <div>
                        <Button onClick={() => setmonthly_record(12)}>All</Button>
                        <Button onClick={() => setmonthly_record(1)}>1M</Button>
                        <Button onClick={() => setmonthly_record(6)}>6M</Button>
                        <Button onClick={() => setmonthly_record(12)}>1Y</Button>
                    </div>
                </div>
                <div className="token">
                    <p>Tokens <span>{'(1000)'}</span></p>
                </div>
            </div>
            <ReactEcharts style={{ height: "400px" }} option={option} />
        </React.Fragment>
    );
};

export { Token_Usage_Chart };
